export default "__VITE_ASSET__B6e7NHn$__"